export default __webpack_public_path__ + "static/assets/8a061f8e13b047da286f16e416cbdbf5.png";